(function() {
    $form = $('.photo-description-form');
    $btn = $('.photo-description-form .btn');
    $name = $('.photo-description-form .name');
    $desc = $('.photo-description-form .description');
    $close = $('.photo-description-form .close');

    $('.pic-description-btn').on('click', function() {
        $form.addClass('show');
        $name.val( $(this).parents('.gallery-item').data('id'));
        $desc.val( $(this).parents('.gallery-item').data('desc'));
    });

    $close.on('click', function () {
        $form.removeClass('show');
        $desc.val('');
        $name.val('');
    });
})();